import {Round, Options} from './types';

const round = (v: number, {decimals, round}: Options) => {
  const fac = Math.pow(10, decimals);
  switch (round) {
    case Round.CEIL:
      return Math.ceil(v * fac) / fac;
    case Round.FLOOR:
      return Math.floor(v * fac) / fac;
    case Round.ROUND:
    default:
      return Math.round(v * fac) / fac;
  }
}

export default round;
